import { Box, Button, Divider } from "@mui/material";

import { Notification } from "../entity";
import { NotificationList } from "./NotificationList";
import { NotificationPopoverSummary } from "./NotificationPopoverSummary";

type NotificationPopoverContentProps = {
  markAllAsRead: () => void;
  notifications: Notification[];
  totalUnRead: number;
};

export const NotificationPopoverContent = ({
  markAllAsRead,
  notifications,
  totalUnRead,
}: NotificationPopoverContentProps) => {
  return (
    <>
      <NotificationPopoverSummary
        markAllAsRead={markAllAsRead}
        totalUnRead={totalUnRead}
      />

      <Divider sx={{ borderStyle: "dashed" }} />

      <NotificationList notifications={notifications} />

      <Divider sx={{ borderStyle: "dashed" }} />

      <Box sx={{ p: 1 }}>
        <Button color="inherit" disableRipple fullWidth>
          View all
        </Button>
      </Box>
    </>
  );
};
